module.exports = __webpack_public_path__ + "img/chevron-icon.a94c6e99.svg";